import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="31cjou2jzrr2f">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-purpleDark/85 md:text-3xl" data-id="element-1" data-mp="2wj8evsjvuu6a">
      Tu próxima sesión puede comenzar de otra manera.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen w-full bg-brand-surface font-sans text-brand-text selection:bg-brand-purple/25 selection:text-brand-purpleDark" data-id="element-2" data-mp="23v2s7099qv3t">
      <UrgencyBanner data-id="element-3" data-mp="3ml14tc2x3ukl" />
      <main data-id="element-4" data-mp="3mkhn9wh6j873">
        <Hero data-id="element-5" data-mp="3mk83wrqn3zad" />
        <PackContents data-id="element-6" data-mp="3mjq3rk0ux0x6" />
        <InitialTestimonials data-id="element-7" data-mp="3rc9f0ac2njyt" />
        <PainPoints data-id="element-8" data-mp="3rbzlwdvqcwow" />
        <LaunchOffer data-id="element-9" data-mp="3rdkh85pvcjnt" />
        <MoreTestimonials data-id="element-10" data-mp="3recerm310rgq" />
        <FAQ data-id="element-11" data-mp="5ygolyg4xb6" />
        <CostComparison data-id="element-12" data-mp="6hovayao7c0" />
        <TransitionPhrase data-id="element-13" data-mp="4n53zyrel9i" />
        <EmotionalClose data-id="element-14" data-mp="82ld64660ci" />
      </main>
      <Footer data-id="element-15" data-mp="2zllf11m4wkmq" />
      <FloatingNotification data-id="element-16" data-mp="2zlv8iz6e19x6" />
    </div>;
}